import React from 'react';

const CollectionDetailsSection = ({ collectionDetails }) => {
    // Initial validation and logging
    // console.log('CollectionDetails received:', collectionDetails);

    if (!collectionDetails || !collectionDetails.data) {
        console.log('CollectionDetails or data is null/undefined');
        return null;
    }

    const { contactDetails, projectDetails } = collectionDetails.data;

    if (!contactDetails && !projectDetails) {
        console.log('Both contactDetails and projectDetails are null/undefined');
        return null;
    }

    return (
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 gap-6">
            {contactDetails && (
                <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
                    <h2 className="text-xl font-bold mb-4 text-blue-700 flex items-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 mr-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                clipRule="evenodd"
                            />
                        </svg>
                        Contact Details
                    </h2>
                    <div className="space-y-3">
                        <div className="flex border-b border-gray-100 pb-2">
                            <span className="text-gray-600 font-medium w-32">Project For:</span>
                            <span className="text-gray-800">
                                {contactDetails.projectFor?.for || '-'}
                            </span>
                        </div>
                        <div className="flex border-b border-gray-100 pb-2">
                            <span className="text-gray-600 font-medium w-32">Name:</span>
                            <span className="text-gray-800">
                                {contactDetails.projectFor?.name || '-'}
                            </span>
                        </div>
                        <div className="flex border-b border-gray-100 pb-2">
                            <span className="text-gray-600 font-medium w-32">Email:</span>
                            <span className="text-gray-800">
                                {contactDetails.projectFor?.email || '-'}
                            </span>
                        </div>
                        <div className="flex border-b border-gray-100 pb-2">
                            <span className="text-gray-600 font-medium w-32">Contact Name:</span>
                            <span className="text-gray-800">
                                {collectionDetails.data.contactDetails.contactName || '-'}
                            </span>
                        </div>
                        <div className="flex border-b border-gray-100 pb-2">
                            <span className="text-gray-600 font-medium w-32">Contact Email:</span>
                            <span className="text-gray-800">
                                {collectionDetails?.data?.contactDetails?.contactEmail ?? '-'}
                            </span>
                        </div>
                        {contactDetails.fields && Object.values(contactDetails.fields).map(field => (
                            field && (
                                <div key={field.question} className="flex border-b border-gray-100 pb-2">
                                    <span className="text-gray-600 font-medium w-32">{field.question || ''}:</span>
                                    <span className="text-gray-800">{field.answer || '-'}</span>
                                </div>
                            )
                        ))}
                    </div>
                </div>
            )}

            {projectDetails && (
                <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
                    <h2 className="text-xl font-bold mb-4 text-blue-700 flex items-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 mr-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 00-1-1H7a1 1 0 00-1 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                                clipRule="evenodd"
                            />
                        </svg>
                        Project Details
                    </h2>
                    <div className="space-y-3">
                        <div className="flex border-b border-gray-100 pb-2">
                            <span className="text-gray-600 font-medium w-32">Address:</span>
                            <span className="text-gray-800">
                                {projectDetails.street1 || '-'}
                                {projectDetails.street2 && (
                                    <>, {projectDetails.street2}</>
                                )}
                            </span>
                        </div>
                        <div className="flex border-b border-gray-100 pb-2">
                            <span className="text-gray-600 font-medium w-32">City:</span>
                            <span className="text-gray-800">
                                {projectDetails.city}
                            </span>
                        </div>
                        <div className="flex border-b border-gray-100 pb-2">
                            <span className="text-gray-600 font-medium w-32">State:</span>
                            <span className="text-gray-800">
                                {projectDetails.state}
                            </span>
                        </div>
                        <div className="flex border-b border-gray-100 pb-2">
                            <span className="text-gray-600 font-medium w-32">Zip Code:</span>
                            <span className="text-gray-800">
                                {projectDetails.zipCode}
                            </span>
                        </div>
                        {projectDetails.fields && Object.values(projectDetails.fields).map(field => (
                            field && (
                                <div key={field.question} className="flex border-b border-gray-100 pb-2">
                                    <span className="text-gray-600 font-medium w-32">{field.question || ''}:</span>
                                    <span className="text-gray-800">{field.answer || '-'}</span>
                                </div>
                            )
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CollectionDetailsSection; 